<template>
  <div class="top-guide" v-if="getH5Plus.isH5Plus && this.$route.meta.showGuide && showFlag && !getShowFlag">
    <img :src="getImgUrl" alt="指南" />
    <i @click="handleClick" class="huisuiyunfont iconfont">&#xe8fe;</i>
    <div class="check">
      <van-checkbox v-model="checked" icon-size="18px" shape="square">不再显示该引导</van-checkbox>
    </div>
  </div>
</template>

<script>
import dpzkzn from '@/assets/img/dpzkzn.png'
import fsfpzn from '@/assets/img/fsfpzn.png'
import fptkzn from '@/assets/img/fptkzn.png'
import { Checkbox } from 'vant'
export default {
  components: {
    [Checkbox.name]: Checkbox
  },
  computed: {
    getImgUrl () {
      let img = dpzkzn
      if (this.$route.fullPath.indexOf('/invoice-opening/index') !== -1) { // 发票填开
        img = fptkzn
      }
      if (this.$route.fullPath.indexOf('/invoice-red/index') !== -1) { // 发票红冲
        img = fsfpzn
      }
      if (this.$route.fullPath.indexOf('/invoice/business/open') !== -1) { // 电票直开
        img = dpzkzn
      }
      return img
    },
    getShowFlag () {
      let flag = false
      if (localStorage.guides) {
        const guides = JSON.parse(localStorage.guides)
        if (this.$route.fullPath.indexOf('/invoice-opening/index') !== -1) { // 发票填开
          flag = guides.fptk
        }
        if (this.$route.fullPath.indexOf('/invoice-red/index') !== -1) { // 发票红冲
          flag = guides.fsfp
        }
        if (this.$route.fullPath.indexOf('/invoice/business/open') !== -1) { // 电票直开
          flag = guides.dpzk
        }
      }
      return flag
    },
    getH5Plus () {
      const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
      return systemconf
    }
  },
  props: {
  },
  data () {
    return {
      checked: false,
      showFlag: true
    }
  },
  methods: {
    handleClick () {
      this.showFlag = false
      if (this.checked) {
        const guides = localStorage.guides ? JSON.parse(localStorage.guides) : {
          fptk: false,
          dpzk: false,
          fsfp: false
        }
        if (this.$route.fullPath.indexOf('/invoice-opening/index') !== -1) { // 发票填开
          guides.fptk = true
        }
        if (this.$route.fullPath.indexOf('/invoice-red/index') !== -1) { // 发票红冲
          guides.fsfp = true
        }
        if (this.$route.fullPath.indexOf('/invoice/business/open') !== -1) { // 电票直开
          guides.dpzk = true
        }
        localStorage.guides = JSON.stringify(guides)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.top-guide{
  width: 100%;
  height: 500px;
  position: relative;
  .check{
    position: absolute;
    font-size: 26px;
    display: flex;
    right: 10px;
    bottom: 5px;
  }
  i{
    position: absolute;
    top: 0;
    right: 0;
  }
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
